import script from "./init.vue?vue&type=script&setup=true&lang=js"
export * from "./init.vue?vue&type=script&setup=true&lang=js"

import "./init.vue?vue&type=style&index=0&id=21bddefb&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bddefb"]])

export default __exports__